export default __webpack_public_path__ + "static/media/logo.d412b6ec.svg";